import Button from '@mui/material/Button';
import { CircularProgress, IconButton } from '@mui/material';
import Stack from '@mui/material/Stack';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Avatar from '@mui/material/Avatar';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import TextField from '../../text-field';
import MyModal from '../modal';
import PencilIcon from '../../../assets/icons/pencil-icon';
import FilterIcon from '../../../assets/icons/filter-icon';
import TableSortIcon from '../../../assets/icons/table-sort-icon';
import SearchIconVariant from '../../../assets/icons/search-icon-variant';
import EditGroupDetailsModal from './edit-group-details/edit-group-details-modal';
import useCreateCustomerModal from './create-customer-group-modal-hooks';
import TablePaginationActions from '../../Pagination/table-pagination-actions';
import ApplyFiltersModal from '../../apply-filters-modal/apply-filters-modal';
import AlertModal from 'components/modals/alert/alert-modal';
import useRetailerBuyerCard from 'pages/customers/components/retailer-buyer-card-hooks';
import useFilterOptions from '../../../pages/customers/components/filter-options-hooks';
import FilterOptions from '../../../pages/customers/components/filter-options';
import Box from '@mui/material/Box';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EmptyState from 'components/empty-state';
import InfoIcon from '@mui/icons-material/Info';

const CreateCustomerGroupModal = ({
  open,
  setOpen,
  edit,
  setEdit,
  data,
  sendApiRequest,
}) => {
  const {
    rowsPerPage,
    handleChangeRowsPerPage,
    page,
    setRowsPerPage,
    onPageChangeHandler,
    handleCheck,
    buyersData,
    selectedBuyers,
    setSelectedBuyers,
    // onSaveHandler,
    showEditGroupDetails,
    setShowEditGroupDetails,
    globalSearchValue,
    setGlobalSearchValue,
    groupNameValue,
    setGroupNameValue,
    groupDescriptionValue,
    setGroupDescriptionValue,
    showApplyFiltersModal,
    setShowApplyFiltersModal,
    showZeroBuyerError,
    setShowZeroBuyerError,
    showBuyers,
    setShowBuyers,
    groups,
    setGroups,
    columnSearchValues,
    setColumnSearchValues,
    salesRep,
    setSalesRep,
    priceGroup,
    setPriceGroup,
    currency,
    setCurrency,
    filterString,
    setFilterString,
    applyFilters,
    sortBuyersColumns,
    isLoading,
    sortColumn,
    setSortColumn,
    isSelectAll,
    setIsSelectAll,
  } = useCreateCustomerModal(data, edit, open);
  const {
    filterCount,
    setFilterCount,
    filterButtonClicked,
    setFilterButtonClicked,
  } = useFilterOptions();

  const { getFirstLetters } = useRetailerBuyerCard();

  function clearFilters() {
    let arrColumnValues = [];
    arrColumnValues = columnSearchValues?.map((column) => {
      if (typeof column.value === 'object') {
        column.value.label = '';
        column.value.value = '';
      } else {
        column.value = '';
      }

      if (document.getElementById('box_' + column.label)) {
        document.getElementById('box_' + column.label).style.backgroundColor =
          '';
      }
      return column;
    });
    setColumnSearchValues(arrColumnValues);
    setGlobalSearchValue('');
  }

  const close = (
    <Button
      variant='outlined'
      color='secondary'
      onClick={(e) => {
        e.preventDefault();
        setOpen(false);
      }}
    >
      Close
    </Button>
  );

  const saveChanges = (
    <Button
      onClick={(e) => {
        e.preventDefault();
        if (selectedBuyers?.length === 0) {
          setShowZeroBuyerError(true);
        } else {
          sendApiRequest(
            groupNameValue,
            groupDescriptionValue,
            isSelectAll ? '' : selectedBuyers,
            isSelectAll
          );
          setOpen(false);
          edit = false;
          setGroupNameValue('Group Name ##');
          setGroupDescriptionValue('Your description here');
          setSelectedBuyers([]);
        }
      }}
      variant='contained'
    >
      Save Changes
    </Button>
  );
  const editIconButton = (
    <IconButton
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (edit) {
          setEdit(true);
        }

        setShowEditGroupDetails(true);
      }}
    >
      <PencilIcon />
    </IconButton>
  );
  return (
    <MyModal
      title={groupNameValue}
      editIconButton={editIconButton}
      subTitle={groupDescriptionValue}
      open={open}
      setOpen={setOpen}
      size='fullWidth'
      showCloseIcon
      actions={[close, saveChanges]}
    >
      <EditGroupDetailsModal
        open={showEditGroupDetails}
        setOpen={setShowEditGroupDetails}
        onSubmithandler={(values) => {
          setGroupNameValue(values.groupName);
          setGroupDescriptionValue(values.groupDesc);
          if (edit) {
            setEdit(false);
          }
        }}
        data={{ name: groupNameValue, description: groupDescriptionValue }}
        edit={edit}
      />

      {/* alert to show when no buyers are selected */}
      <AlertModal
        open={showZeroBuyerError}
        setOpen={setShowZeroBuyerError}
        title='Please select at least one buyer'
        type='warning'
      />

      {isLoading ? (
        <Box
          width='100vw'
          height='100vh'
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 9999,
            opacity: 0.4,
            backgroundColor: '#000',
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
      <Stack spacing={3} sx={{ padding: '18px 25px 18px 25px' }}>
        {/* <Stack direction='row' justifyContent='space-between'>
          <TextField
            value={globalSearchValue}
            placeholder='Search'
            startAdornment={<SearchIconVariant />}
            onChange={(e) => setGlobalSearchValue(e.target.value)}
            sx={{
              width: '740px',
              paddingLeft: '10px',
            }}
          />
        </Stack> */}
        {/* tablecontainer */}
        <FilterOptions
          setSearchValue={setGlobalSearchValue}
          searchValue={globalSearchValue}
          salesRep={salesRep}
          setSalesRep={setSalesRep}
          priceGroup={priceGroup}
          setPriceGroup={setPriceGroup}
          currency={currency}
          setCurrency={setCurrency}
          showBuyers={showBuyers}
          setShowBuyers={setShowBuyers}
          applyFilters={applyFilters}
          buyer={true}
          clearFilters={clearFilters}
        />
        <Box>
          <Stack
            direction='row'
            spacing={1}
            sx={{
              paddingLeft: '10px',
              alignItems: 'center',
              border: '1px solid #E3E7ED',
            }}
          >
            <Checkbox
              checked={
                isSelectAll ||
                (buyersData?.data?.length > 0
                  ? selectedBuyers.length === buyersData?.data?.length
                  : false)
              }
              onClick={(e) => {
                if (isSelectAll) {
                  setSelectedBuyers([]);
                } else {
                  buyersData?.data?.forEach((buyer) => {
                    setSelectedBuyers((prev) => {
                      return [...prev, buyer?.id];
                    });
                  });
                }
                setIsSelectAll(!isSelectAll);
              }}
            />
            <Typography>
              {isSelectAll
                ? ` All ${buyersData?.count} buyers are selected`
                : `(${selectedBuyers.length} Buyers Selected)`}
            </Typography>
            <Button
              variant='text'
              sx={{ color: '#008CD6' }}
              onClick={() => {
                if (isSelectAll) {
                  setSelectedBuyers([]);
                } else {
                  buyersData?.data?.forEach((buyer) => {
                    setSelectedBuyers((prev) => {
                      return [...prev, buyer?.id];
                    });
                  });
                }
                setIsSelectAll(!isSelectAll);
              }}
            >
              {isSelectAll ? `Undo` : ' Select All Buyers from the list'}
            </Button>
          </Stack>
          <TableContainer sx={{ width: '100%' }}>
            <Table
              size='small'
              sx={{
                border: '1px solid var(--secondary-border-color)',
                width: '100%',
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('buyerName')}
                  >
                    BUYER NAME &nbsp;
                    <IconButton onClick={() => sortBuyersColumns('buyerName')}>
                      {sortColumn.columnName === 'buyerName' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('retailer')}
                  >
                    RETAILER &nbsp;
                    <IconButton onClick={() => sortBuyersColumns('retailer')}>
                      {sortColumn.columnName === 'retailer' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('Account')}
                  >
                    ACCOUNT &nbsp;
                    <IconButton onClick={() => sortBuyersColumns('Account')}>
                      {sortColumn.columnName === 'Account' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('city')}
                  >
                    CITY &nbsp;
                    <IconButton onClick={() => sortBuyersColumns('city')}>
                      {sortColumn.columnName === 'city' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('state')}
                  >
                    STATE &nbsp;
                    <IconButton onClick={() => sortBuyersColumns('state')}>
                      {sortColumn.columnName === 'state' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('country')}
                  >
                    COUNTRY &nbsp;
                    <IconButton onClick={() => sortBuyersColumns('country')}>
                      {sortColumn.columnName === 'country' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('businessPhone')}
                  >
                    BUSINESS PHONE &nbsp;
                    <IconButton
                      onClick={() => sortBuyersColumns('businessPhone')}
                    >
                      {sortColumn.columnName === 'businessPhone' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{ cursor: 'pointer' }}
                    onClick={() => sortBuyersColumns('mobilePhone')}
                  >
                    BUSINESS PHONE &nbsp;
                    <IconButton
                      onClick={() => sortBuyersColumns('mobilePhone')}
                    >
                      {sortColumn.columnName === 'mobilePhone' ? (
                        sortColumn.sortType === 'DESC' ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )
                      ) : (
                        <TableSortIcon />
                      )}
                    </IconButton>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <>
                  <TableRow>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='buyerName'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'buyerName') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'buyerName')
                                searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'buyerName',
                              value: e.target.value,
                            });

                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_buyerName'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_buyerName'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='retailer'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'retailer') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'retailer')
                                searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'retailer',
                              value: e.target.value,
                            });

                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_retailer'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_retailer'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='Account'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'Account') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'Account')
                                searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'Account',
                              value: e.target.value,
                            });

                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_Account'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_Account'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='city'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'city') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'city') searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'city',
                              value: e.target.value,
                            });
                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_city'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_city'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='state'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'state') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'state') searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'state',
                              value: e.target.value,
                            });
                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_state'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_state'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='country'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'country') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'country')
                                searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'country',
                              value: e.target.value,
                            });
                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_country'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_country'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='businessPhone'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'businessPhone') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'businessPhone')
                                searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'businessPhone',
                              value: e.target.value,
                            });
                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_businessPhone'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_businessPhone'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        placeholder='Search'
                        id='mobilePhone'
                        startAdornment={
                          <SearchIconVariant sx={{ marginRight: '6px' }} />
                        }
                        value={(() => {
                          var val = '';
                          columnSearchValues.forEach((obj) => {
                            if (obj.label === 'mobilePhone') {
                              val = obj.value;
                            }
                          });
                          return val;
                        })()}
                        onChange={(e) => {
                          e.preventDefault();
                          (() => {
                            var searchValues = [];
                            columnSearchValues.forEach((obj) => {
                              if (obj.label !== 'mobilePhone')
                                searchValues.push(obj);
                            });
                            searchValues.push({
                              label: 'mobilePhone',
                              value: e.target.value,
                            });
                            if (e.target.value !== '') {
                              document.getElementById(
                                'box_mobilePhone'
                              ).style.backgroundColor = '#cfe2ff';
                            } else {
                              document.getElementById(
                                'box_mobilePhone'
                              ).style.backgroundColor = '';
                            }
                            setColumnSearchValues(searchValues);
                          })();
                        }}
                        sx={{
                          marginBottom: 0,
                          height: '28px',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          backgroundColor: 'inherit',
                        }}
                      />
                    </TableCell>
                  </TableRow>
                  {buyersData &&
                    buyersData.data.map((row, i) => (
                      <TableRow key={i}>
                        {/* <TableCell sx={{ fontWeight: 900 }}>{row.accname}</TableCell> */}
                        <TableCell>
                          <Stack
                            direction='row'
                            spacing={1}
                            alignItems='center'
                          >
                            <Checkbox
                              checked={(() => {
                                var x = false;
                                selectedBuyers?.forEach((item) => {
                                  if (item === row.id) x = true;
                                });
                                return x;
                              })()}
                              onClick={(e) => {
                                e.preventDefault();
                                handleCheck(row);
                              }}
                            />
                            {row?.profile_pic ? (
                              <img
                                src={row.profile_pic}
                                style={{ width: '30px', height: '30px' }}
                              />
                            ) : (
                              <Avatar
                                size='small'
                                sx={{ width: '30px', height: '30px' }}
                              >
                                {getFirstLetters(row?.buyerName)}
                              </Avatar>
                            )}
                            <Typography
                              sx={{
                                color: 'var(--primary-font-color)',
                                fontSize: '15px',
                                fontWeight: '900',
                              }}
                            >
                              {row.buyerName}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell>{row.retailer}</TableCell>
                        <TableCell>{row.Account}</TableCell>
                        <TableCell>{row.city}</TableCell>
                        <TableCell>{row.state}</TableCell>
                        <TableCell>{row.country}</TableCell>
                        <TableCell>{row.businessPhone}</TableCell>
                        <TableCell>{row.mobilePhone}</TableCell>
                      </TableRow>
                    ))}
                </>
              </TableBody>
              <TableFooter>
                {buyersData && buyersData.data.length === 0 ? (
                  <TableCell colspan='8'>
                    {' '}
                    <EmptyState
                      title='No records found'
                      subTitle='We couldnt find any Records. Try adjusting your filters to display results'
                      icon={
                        <InfoIcon
                          sx={{
                            fontSize: 60,
                            color: 'var(--primary-icon-color)',
                          }}
                        />
                      }
                      sx={{
                        border: '1px solid var(--secondary-border-color)',
                        height: '150px',
                      }}
                    />
                  </TableCell>
                ) : null}
              </TableFooter>
            </Table>
          </TableContainer>
          {/* tablecontainer ends */}
          {buyersData && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'right',
                border: '1px solid var(--secondary-border-color)',
              }}
            >
              <TablePagination
                rowsPerPageOptions={[
                  25, 50, 100 /*{ label: 'All', value: buyersData.count - 1 }*/,
                ]}
                count={buyersData.count}
                onPageChange={onPageChangeHandler}
                rowsPerPage={
                  buyersData?.count < 25 ? buyersData.count : rowsPerPage
                }
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={page}
                ActionsComponent={TablePaginationActions}
                sx={{ border: 0 }}
              />
            </Box>
          )}
        </Box>
      </Stack>
    </MyModal>
  );
};

CreateCustomerGroupModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  edit: PropTypes.bool.isRequired,
  data: PropTypes.object,
  sendApiRequest: PropTypes.func.isRequired,
  setEdit: PropTypes.func,
};
CreateCustomerGroupModal.defaultProps = {
  data: null,
  edit: false,
  setEdit: () => {},
};

export default CreateCustomerGroupModal;
